import { ProjectRepository } from 'core/repositories/ProjectRepository';
import { Project } from 'core/models/project';
import { ApiCall } from './api/apiCall';
import { ProjectsResponse } from './api/Role';

class ApiProjectRepository implements ProjectRepository {
    private readonly apiCall: ApiCall;

    constructor(apiCall: ApiCall) {
        this.apiCall = apiCall;
    }

    async getProjects(): Promise<Project[]> {
        try {
            const res = await this.apiCall<ProjectsResponse>('/v2/projects');
            return res.projects.map(p => Object.assign(p, { name: p.display_name }));
        } catch (e) {
            console.warn(e);
            return [];
        }
    }
}

export { ApiProjectRepository as ProjectRepository };
